export function createShareText(platform: 'facebook' | 'twitter' | 'email' | 'whatsapp' | 'url', headline?: string | null): string {
	// Twitter shares the headline of the article in tweet text, so we add this one here.
	if (!headline) {
		return '';
	}
	switch (platform) {
		case 'twitter':
		case 'whatsapp': {
			return headline;
		}
	}

	return '';
}
